import { call } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';

export const useOffRampingFeeRate = () => {
  return useQuery({
    queryKey: ['settings', 'off-ramping-fee'],
    staleTime: 1000 * 60 * 30,
    queryFn: () =>
      call<{ rate: number }>('settings/off-ramping-fee').then((res) =>
        res.json(),
      ),
    select: (data) => data.rate,
  });
};
